(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('[vaul-drawer]{touch-action:none;transform:translate3d(0,100%,0);transition:transform .5s cubic-bezier(.32,.72,0,1)}.vaul-dragging .vaul-scrollable{overflow-y:hidden!important}[vaul-drawer][vaul-drawer-visible=true]{transform:translate3d(0,var(--snap-point-height, 0),0)}[vaul-overlay]{opacity:0;transition:opacity .5s cubic-bezier(.32,.72,0,1)}[vaul-overlay][vaul-drawer-visible=true]{opacity:1}[vaul-drawer]:after{content:"";position:absolute;top:100%;background:inherit;background-color:inherit;left:0;right:0;height:200%}[vaul-overlay][vaul-snap-points=true]:not([vaul-snap-points-overlay=true]):not([data-state=closed]){opacity:0}[vaul-overlay][vaul-snap-points-overlay=true]:not([vaul-drawer-visible=false]){opacity:1}@keyframes fake-animation{}@media (hover: hover) and (pointer: fine){[vaul-drawer]{-webkit-user-select:none;user-select:none}}')),document.head.appendChild(e)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import { computed as _, defineComponent as S, mergeProps as U, cloneVNode as Rt, h as ie, toRefs as Ne, ref as b, getCurrentInstance as Y, renderSlot as M, onMounted as ue, openBlock as C, createBlock as B, unref as f, withCtx as R, normalizeProps as Mt, guardReactiveProps as xt, reactive as Qe, createVNode as Ze, createCommentVNode as et, watch as k, watchEffect as te, markRaw as Ve, inject as It, provide as Lt, effectScope as tt, nextTick as G, Fragment as jt, toHandlerKey as kt, camelize as nt, toRef as Ft, onUnmounted as Ce, Teleport as Ut, onBeforeUnmount as Wt, normalizeStyle as ot, getCurrentScope as Ht, onScopeDispose as Vt } from "vue";
function be(e, t) {
  const n = typeof e == "string" && !t ? `${e}Context` : t, o = Symbol(n);
  return [(a) => {
    const r = It(o, a);
    if (r || r === null)
      return r;
    throw new Error(
      `Injection \`${o.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(
        ", "
      )}` : `\`${e}\``}`
    );
  }, (a) => (Lt(o, a), a)];
}
function at(e, t, n) {
  const o = n.originalEvent.target, a = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, { once: !0 }), o.dispatchEvent(a);
}
function rt(e) {
  return Ht() ? (Vt(e), !0) : !1;
}
function lt(e) {
  let t = !1, n;
  const o = tt(!0);
  return (...a) => (t || (n = o.run(() => e(...a)), t = !0), n);
}
function zt(e) {
  let t = 0, n, o;
  const a = () => {
    t -= 1, o && t <= 0 && (o.stop(), n = void 0, o = void 0);
  };
  return (...r) => (t += 1, n || (o = tt(!0), n = o.run(() => e(...r))), rt(a), n);
}
function Be(e) {
  return typeof e == "function" ? e() : f(e);
}
const le = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Kt = (e) => typeof e < "u", Yt = Object.prototype.toString, qt = (e) => Yt.call(e) === "[object Object]", Jt = () => {
}, ze = /* @__PURE__ */ Gt();
function Gt() {
  var e, t;
  return le && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Xt(e) {
  return e || Y();
}
function Qt(e, t) {
  Xt(t) && Wt(e, t);
}
function ce(e) {
  var t;
  const n = Be(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const st = le ? window : void 0;
function it(...e) {
  let t, n, o, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, a] = e, t = st) : [t, n, o, a] = e, !t)
    return Jt;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const r = [], s = () => {
    r.forEach((c) => c()), r.length = 0;
  }, u = (c, l, p, m) => (c.addEventListener(l, p, m), () => c.removeEventListener(l, p, m)), d = k(
    () => [ce(t), Be(a)],
    ([c, l]) => {
      if (s(), !c)
        return;
      const p = qt(l) ? { ...l } : l;
      r.push(
        ...n.flatMap((m) => o.map((y) => u(c, m, y, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), i = () => {
    d(), s();
  };
  return rt(i), i;
}
function Zt(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function en(...e) {
  let t, n, o = {};
  e.length === 3 ? (t = e[0], n = e[1], o = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], o = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: a = st,
    eventName: r = "keydown",
    passive: s = !1,
    dedupe: u = !1
  } = o, d = Zt(t);
  return it(a, r, (i) => {
    i.repeat && Be(u) || d(i) && n(i);
  }, s);
}
function tn() {
  const e = b(!1), t = Y();
  return t && ue(() => {
    e.value = !0;
  }, t), e;
}
function nn(e) {
  return JSON.parse(JSON.stringify(e));
}
function on(e, t, n, o = {}) {
  var a, r, s;
  const {
    clone: u = !1,
    passive: d = !1,
    eventName: i,
    deep: c = !1,
    defaultValue: l,
    shouldEmit: p
  } = o, m = Y(), y = n || (m == null ? void 0 : m.emit) || ((a = m == null ? void 0 : m.$emit) == null ? void 0 : a.bind(m)) || ((s = (r = m == null ? void 0 : m.proxy) == null ? void 0 : r.$emit) == null ? void 0 : s.bind(m == null ? void 0 : m.proxy));
  let v = i;
  t || (t = "modelValue"), v = v || `update:${t.toString()}`;
  const g = (h) => u ? typeof u == "function" ? u(h) : nn(h) : h, O = () => Kt(e[t]) ? g(e[t]) : l, x = (h) => {
    p ? p(h) && y(v, h) : y(v, h);
  };
  if (d) {
    const h = O(), P = b(h);
    let A = !1;
    return k(
      () => e[t],
      (L) => {
        A || (A = !0, P.value = g(L), G(() => A = !1));
      }
    ), k(
      P,
      (L) => {
        !A && (L !== e[t] || c) && x(L);
      },
      { deep: c }
    ), P;
  } else
    return _({
      get() {
        return O();
      },
      set(h) {
        x(h);
      }
    });
}
function Re(e) {
  return e ? e.flatMap((t) => t.type === jt ? Re(t.children) : [t]) : [];
}
function $e(e) {
  if (e === null || typeof e != "object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || Symbol.iterator in e ? !1 : Symbol.toStringTag in e ? Object.prototype.toString.call(e) === "[object Module]" : !0;
}
function Pe(e, t, n = ".", o) {
  if (!$e(t))
    return Pe(e, {}, n, o);
  const a = Object.assign({}, t);
  for (const r in e) {
    if (r === "__proto__" || r === "constructor")
      continue;
    const s = e[r];
    s != null && (o && o(a, r, s, n) || (Array.isArray(s) && Array.isArray(a[r]) ? a[r] = [...s, ...a[r]] : $e(s) && $e(a[r]) ? a[r] = Pe(
      s,
      a[r],
      (n ? `${n}.` : "") + r.toString(),
      o
    ) : a[r] = s));
  }
  return a;
}
function an(e) {
  return (...t) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    t.reduce((n, o) => Pe(n, o, "", e), {})
  );
}
const rn = an(), [ln, no] = be("ConfigProvider"), sn = lt(() => ({ count: b(0) }));
function he(e) {
  const { count: t } = sn();
  return e || t.value++, e || `radix-${t.value}`;
}
const un = zt(() => {
  const e = b(/* @__PURE__ */ new Map()), t = b(), n = _(() => {
    for (const s of e.value.values())
      if (s)
        return !0;
    return !1;
  }), o = ln({
    scrollBody: b(!0)
  });
  let a = null;
  const r = () => {
    document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = t.value ?? "", ze && (a == null || a()), t.value = void 0;
  };
  return k(n, (s, u) => {
    var d;
    if (!le)
      return;
    if (!s) {
      u && r();
      return;
    }
    t.value === void 0 && (t.value = document.body.style.overflow);
    const i = window.innerWidth - document.documentElement.clientWidth, c = { padding: i, margin: 0 }, l = (d = o.scrollBody) != null && d.value ? typeof o.scrollBody.value == "object" ? rn({
      padding: o.scrollBody.value.padding === !0 ? i : o.scrollBody.value.padding,
      margin: o.scrollBody.value.margin === !0 ? i : o.scrollBody.value.margin
    }, c) : c : { padding: 0, margin: 0 };
    i > 0 && (document.body.style.paddingRight = `${l.padding}px`, document.body.style.marginRight = `${l.margin}px`, document.body.style.setProperty("--scrollbar-width", `${i}px`), document.body.style.overflow = "hidden"), ze && (a = it(
      document,
      "touchmove",
      (p) => {
        var m;
        p.target === document.documentElement && (p.touches.length > 1 || (m = p.preventDefault) == null || m.call(p));
      },
      { passive: !1 }
    )), G(() => {
      document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
    });
  }, { immediate: !0, flush: "sync" }), e;
});
function cn(e) {
  const t = he(), n = un();
  n.value.set(t, e ?? !1);
  const o = _({
    get: () => n.value.get(t) ?? !1,
    set: (a) => n.value.set(t, a)
  });
  return Qt(() => {
    n.value.delete(t);
  }), o;
}
function we(e) {
  const t = Y(), n = t == null ? void 0 : t.type.emits, o = {};
  return n != null && n.length || console.warn(
    `No emitted event found. Please check component: ${t == null ? void 0 : t.type.__name}`
  ), n == null || n.forEach((a) => {
    o[kt(nt(a))] = (...r) => e(a, ...r);
  }), o;
}
function dn(e) {
  const t = Y(), n = Object.keys((t == null ? void 0 : t.type.props) ?? {}).reduce((a, r) => {
    const s = (t == null ? void 0 : t.type.props[r]).default;
    return s !== void 0 && (a[r] = s), a;
  }, {}), o = Ft(e);
  return _(() => {
    const a = {}, r = (t == null ? void 0 : t.vnode.props) ?? {};
    return Object.keys(r).forEach((s) => {
      a[nt(s)] = r[s];
    }), Object.keys({ ...n, ...a }).reduce((s, u) => (o.value[u] !== void 0 && (s[u] = o.value[u]), s), {});
  });
}
function pn(e, t) {
  const n = dn(e), o = t ? we(t) : {};
  return _(() => ({
    ...n.value,
    ...o
  }));
}
function W() {
  const e = Y(), t = b(), n = _(() => {
    var s, u;
    return ["#text", "#comment"].includes((s = t.value) == null ? void 0 : s.$el.nodeName) ? (u = t.value) == null ? void 0 : u.$el.nextElementSibling : ce(t);
  }), o = Object.assign({}, e.exposed), a = {};
  for (const s in e.props)
    Object.defineProperty(a, s, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[s]
    });
  if (Object.keys(o).length > 0)
    for (const s in o)
      Object.defineProperty(a, s, {
        enumerable: !0,
        configurable: !0,
        get: () => o[s]
      });
  Object.defineProperty(a, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => e.vnode.el
  }), e.exposed = a;
  function r(s) {
    t.value = s, !(s instanceof Element || !s) && (Object.defineProperty(a, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => s.$el
    }), e.exposed = a);
  }
  return { forwardRef: r, currentRef: t, currentElement: n };
}
var vn = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, re = /* @__PURE__ */ new WeakMap(), fe = /* @__PURE__ */ new WeakMap(), me = {}, Ae = 0, ut = function(e) {
  return e && (e.host || ut(e.parentNode));
}, fn = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = ut(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, mn = function(e, t, n, o) {
  var a = fn(t, Array.isArray(e) ? e : [e]);
  me[n] || (me[n] = /* @__PURE__ */ new WeakMap());
  var r = me[n], s = [], u = /* @__PURE__ */ new Set(), d = new Set(a), i = function(l) {
    !l || u.has(l) || (u.add(l), i(l.parentNode));
  };
  a.forEach(i);
  var c = function(l) {
    !l || d.has(l) || Array.prototype.forEach.call(l.children, function(p) {
      if (u.has(p))
        c(p);
      else {
        var m = p.getAttribute(o), y = m !== null && m !== "false", v = (re.get(p) || 0) + 1, g = (r.get(p) || 0) + 1;
        re.set(p, v), r.set(p, g), s.push(p), v === 1 && y && fe.set(p, !0), g === 1 && p.setAttribute(n, "true"), y || p.setAttribute(o, "true");
      }
    });
  };
  return c(t), u.clear(), Ae++, function() {
    s.forEach(function(l) {
      var p = re.get(l) - 1, m = r.get(l) - 1;
      re.set(l, p), r.set(l, m), p || (fe.has(l) || l.removeAttribute(o), fe.delete(l)), m || l.removeAttribute(n);
    }), Ae--, Ae || (re = /* @__PURE__ */ new WeakMap(), re = /* @__PURE__ */ new WeakMap(), fe = /* @__PURE__ */ new WeakMap(), me = {});
  };
}, yn = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), a = t || vn(e);
  return a ? (o.push.apply(o, Array.from(a.querySelectorAll("[aria-live]"))), mn(o, a, n, "aria-hidden")) : function() {
    return null;
  };
};
function gn(e) {
  let t;
  k(() => ce(e), (n) => {
    n ? t = yn(n) : t && t();
  }), Ce(() => {
    t && t();
  });
}
function hn(e, t) {
  const n = b(e);
  function o(a) {
    return t[n.value][a] ?? n.value;
  }
  return {
    state: n,
    dispatch: (a) => {
      n.value = o(a);
    }
  };
}
const Me = S({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(e, { attrs: t, slots: n }) {
    return () => {
      var o, a;
      if (!n.default)
        return null;
      const r = Re(n.default()), [s, ...u] = r;
      if (Object.keys(t).length > 0) {
        (o = s.props) == null || delete o.ref;
        const d = U(t, s.props ?? {});
        t.class && (a = s.props) != null && a.class && delete s.props.class;
        const i = Rt(s, d);
        for (const c in d)
          c.startsWith("on") && (i.props || (i.props = {}), i.props[c] = d[c]);
        return r.length === 1 ? i : [i, ...u];
      }
      return r;
    };
  }
}), ne = S({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(e, { attrs: t, slots: n }) {
    return (e.asChild ? "template" : e.as) !== "template" ? () => ie(e.as, t, { default: n.default }) : () => ie(Me, t, { default: n.default });
  }
});
function ct() {
  const e = b(), t = _(() => {
    var n, o;
    return ["#text", "#comment"].includes((n = e.value) == null ? void 0 : n.$el.nodeName) ? (o = e.value) == null ? void 0 : o.$el.nextElementSibling : ce(e);
  });
  return {
    primitiveElement: e,
    currentElement: t
  };
}
function bn(e, t) {
  const n = b({}), o = b("none"), a = e.value ? "mounted" : "unmounted", { state: r, dispatch: s } = hn(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  k(
    e,
    async (l, p) => {
      var m;
      const y = p !== l;
      if (await G(), y) {
        const v = o.value, g = ye(t.value);
        l ? s("MOUNT") : g === "none" || ((m = n.value) == null ? void 0 : m.display) === "none" ? s("UNMOUNT") : s(p && v !== g ? "ANIMATION_OUT" : "UNMOUNT");
      }
    },
    { immediate: !0 }
  );
  const u = (l) => {
    const p = ye(t.value), m = p.includes(
      l.animationName
    );
    l.target === t.value && m && s("ANIMATION_END"), l.target === t.value && p === "none" && s("ANIMATION_END");
  }, d = (l) => {
    l.target === t.value && (o.value = ye(t.value));
  }, i = k(
    t,
    (l, p) => {
      l ? (n.value = getComputedStyle(l), l.addEventListener("animationstart", d), l.addEventListener("animationcancel", u), l.addEventListener("animationend", u)) : (s("ANIMATION_END"), p == null || p.removeEventListener("animationstart", d), p == null || p.removeEventListener("animationcancel", u), p == null || p.removeEventListener("animationend", u));
    },
    { immediate: !0 }
  ), c = k(r, () => {
    const l = ye(t.value);
    o.value = r.value === "mounted" ? l : "none";
  });
  return Ce(() => {
    i(), c();
  }), {
    isPresent: _(
      () => ["mounted", "unmountSuspended"].includes(r.value)
    )
  };
}
function ye(e) {
  return e && getComputedStyle(e).animationName || "none";
}
const dt = S({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(e, { slots: t, expose: n }) {
    var o;
    const { present: a, forceMount: r } = Ne(e), s = b(), { isPresent: u } = bn(a, s);
    n({ present: u });
    let d = t.default({ present: u });
    d = Re(d || []);
    const i = Y();
    if (d && (d == null ? void 0 : d.length) > 1) {
      const c = (o = i == null ? void 0 : i.parent) != null && o.type.name ? `<${i.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${c}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((l) => `  - ${l}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => r.value || a.value || u.value ? ie(t.default({ present: u })[0], {
      ref: (c) => {
        const l = ce(c);
        return typeof (l == null ? void 0 : l.hasAttribute) > "u" || (l != null && l.hasAttribute("data-radix-popper-content-wrapper") ? s.value = l.firstElementChild : s.value = l), l;
      }
    }) : null;
  }
}), [V, wn] = be("DialogRoot"), On = /* @__PURE__ */ S({
  __name: "DialogRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(e, { emit: t }) {
    const n = e, o = on(n, "open", t, {
      defaultValue: n.defaultOpen,
      passive: n.open === void 0
    }), a = b(), r = b(), { modal: s } = Ne(n);
    return wn({
      open: o,
      modal: s,
      openModal: () => {
        o.value = !0;
      },
      onOpenChange: (u) => {
        o.value = u;
      },
      onOpenToggle: () => {
        o.value = !o.value;
      },
      contentId: he(),
      titleId: he(),
      descriptionId: he(),
      triggerElement: a,
      contentElement: r
    }), (u, d) => M(u.$slots, "default");
  }
}), oo = /* @__PURE__ */ S({
  __name: "DialogTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, n = V(), { forwardRef: o, currentElement: a } = W();
    return ue(() => {
      n.triggerElement = a;
    }), (r, s) => (C(), B(f(ne), U(t, {
      ref: f(o),
      type: r.as === "button" ? "button" : void 0,
      "aria-haspopup": "dialog",
      "aria-expanded": f(n).open.value || !1,
      "aria-controls": f(n).contentId,
      "data-state": f(n).open.value ? "open" : "closed",
      onClick: f(n).onOpenToggle
    }), {
      default: R(() => [
        M(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "onClick"]));
  }
}), En = /* @__PURE__ */ S({
  __name: "Teleport",
  props: {
    to: { default: "body" },
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const t = tn();
    return (n, o) => f(t) || n.forceMount ? (C(), B(Ut, {
      key: 0,
      to: n.to,
      disabled: n.disabled
    }, [
      M(n.$slots, "default")
    ], 8, ["to", "disabled"])) : et("", !0);
  }
}), ao = /* @__PURE__ */ S({
  __name: "DialogPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, o) => (C(), B(f(En), Mt(xt(t)), {
      default: R(() => [
        M(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Dn = "dismissableLayer.pointerDownOutside", $n = "dismissableLayer.focusOutside";
function pt(e, t) {
  const n = t.closest(
    "[data-dismissable-layer]"
  ), o = e.querySelector(
    "[data-dismissable-layer]"
  ), a = Array.from(
    e.ownerDocument.querySelectorAll("[data-dismissable-layer]")
  );
  return !!(n && o === n || a.indexOf(o) < a.indexOf(n));
}
function An(e, t) {
  var n;
  const o = ((n = t == null ? void 0 : t.value) == null ? void 0 : n.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), a = b(!1), r = b(() => {
  });
  return te((s) => {
    if (!le)
      return;
    const u = async (i) => {
      const c = i.target;
      if (t != null && t.value) {
        if (pt(t.value, c)) {
          a.value = !1;
          return;
        }
        if (i.target && !a.value) {
          let l = function() {
            at(
              Dn,
              e,
              p
            );
          };
          const p = { originalEvent: i };
          i.pointerType === "touch" ? (o.removeEventListener("click", r.value), r.value = l, o.addEventListener("click", r.value, {
            once: !0
          })) : l();
        } else
          o.removeEventListener("click", r.value);
        a.value = !1;
      }
    }, d = window.setTimeout(() => {
      o.addEventListener("pointerdown", u);
    }, 0);
    s(() => {
      window.clearTimeout(d), o.removeEventListener("pointerdown", u), o.removeEventListener("click", r.value);
    });
  }), {
    onPointerDownCapture: () => a.value = !0
  };
}
function Sn(e, t) {
  var n;
  const o = ((n = t == null ? void 0 : t.value) == null ? void 0 : n.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), a = b(!1);
  return te((r) => {
    if (!le)
      return;
    const s = async (u) => {
      t != null && t.value && (await G(), !(!t.value || pt(t.value, u.target)) && u.target && !a.value && at(
        $n,
        e,
        { originalEvent: u }
      ));
    };
    o.addEventListener("focusin", s), r(() => o.removeEventListener("focusin", s));
  }), {
    onFocusCapture: () => a.value = !0,
    onBlurCapture: () => a.value = !1
  };
}
const K = Qe({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Tn = /* @__PURE__ */ S({
  __name: "DismissableLayer",
  props: {
    disableOutsidePointerEvents: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(e, { emit: t }) {
    const n = e, o = t, { forwardRef: a, currentElement: r } = W(), s = _(
      () => {
        var y;
        return ((y = r.value) == null ? void 0 : y.ownerDocument) ?? globalThis.document;
      }
    ), u = _(() => K.layersRoot), d = _(() => r.value ? Array.from(u.value).indexOf(r.value) : -1), i = _(() => K.layersWithOutsidePointerEventsDisabled.size > 0), c = _(() => {
      const y = Array.from(u.value), [v] = [...K.layersWithOutsidePointerEventsDisabled].slice(-1), g = y.indexOf(v);
      return d.value >= g;
    }), l = An(async (y) => {
      const v = [...K.branches].some(
        (g) => g.contains(y.target)
      );
      !c.value || v || (o("pointerDownOutside", y), o("interactOutside", y), await G(), y.defaultPrevented || o("dismiss"));
    }, r), p = Sn((y) => {
      [...K.branches].some(
        (v) => v.contains(y.target)
      ) || (o("focusOutside", y), o("interactOutside", y), y.defaultPrevented || o("dismiss"));
    }, r);
    en("Escape", (y) => {
      d.value === u.value.size - 1 && (o("escapeKeyDown", y), y.defaultPrevented || o("dismiss"));
    });
    let m;
    return te((y) => {
      r.value && (n.disableOutsidePointerEvents && (K.layersWithOutsidePointerEventsDisabled.size === 0 && (m = s.value.body.style.pointerEvents, s.value.body.style.pointerEvents = "none"), K.layersWithOutsidePointerEventsDisabled.add(r.value)), u.value.add(r.value), y(() => {
        n.disableOutsidePointerEvents && K.layersWithOutsidePointerEventsDisabled.size === 1 && (s.value.body.style.pointerEvents = m);
      }));
    }), te((y) => {
      y(() => {
        r.value && (u.value.delete(r.value), K.layersWithOutsidePointerEventsDisabled.delete(r.value));
      });
    }), (y, v) => (C(), B(f(ne), {
      ref: f(a),
      "as-child": y.asChild,
      as: y.as,
      "data-dismissable-layer": "",
      style: ot({
        pointerEvents: i.value ? c.value ? "auto" : "none" : void 0
      }),
      onFocusCapture: f(p).onFocusCapture,
      onBlurCapture: f(p).onBlurCapture,
      onPointerdownCapture: f(l).onPointerDownCapture
    }, {
      default: R(() => [
        M(y.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "style", "onFocusCapture", "onBlurCapture", "onPointerdownCapture"]));
  }
}), Se = "focusScope.autoFocusOnMount", Te = "focusScope.autoFocusOnUnmount", Ke = { bubbles: !1, cancelable: !0 };
function _n(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (J(o, { select: t }), document.activeElement !== n)
      return !0;
}
function Pn(e) {
  const t = vt(e), n = Ye(t, e), o = Ye(t.reverse(), e);
  return [n, o];
}
function vt(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const a = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || a ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Ye(e, t) {
  for (const n of e)
    if (!Nn(n, { upTo: t }))
      return n;
}
function Nn(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Cn(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function J(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Cn(e) && t && e.select();
  }
}
const Bn = lt(() => b([]));
function Rn() {
  const e = Bn();
  return {
    add(t) {
      const n = e.value[0];
      t !== n && (n == null || n.pause()), e.value = qe(e.value, t), e.value.unshift(t);
    },
    remove(t) {
      var n;
      e.value = qe(e.value, t), (n = e.value[0]) == null || n.resume();
    }
  };
}
function qe(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function Mn(e) {
  return e.filter((t) => t.tagName !== "A");
}
const xn = /* @__PURE__ */ S({
  __name: "FocusScope",
  props: {
    loop: { type: Boolean, default: !1 },
    trapped: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["mountAutoFocus", "unmountAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, { currentRef: a, currentElement: r } = W(), s = b(null), u = Rn(), d = Qe({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    });
    te((c) => {
      if (!le)
        return;
      const l = r.value;
      if (!n.trapped)
        return;
      function p(g) {
        if (d.paused || !l)
          return;
        const O = g.target;
        l.contains(O) ? s.value = O : J(s.value, { select: !0 });
      }
      function m(g) {
        if (d.paused || !l)
          return;
        const O = g.relatedTarget;
        O !== null && (l.contains(O) || J(s.value, { select: !0 }));
      }
      function y(g) {
        l.contains(s.value) || J(l);
      }
      document.addEventListener("focusin", p), document.addEventListener("focusout", m);
      const v = new MutationObserver(y);
      l && v.observe(l, { childList: !0, subtree: !0 }), c(() => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m), v.disconnect();
      });
    }), te(async (c) => {
      const l = r.value;
      if (await G(), !l)
        return;
      u.add(d);
      const p = document.activeElement;
      if (!l.contains(p)) {
        const m = new CustomEvent(Se, Ke);
        l.addEventListener(
          Se,
          (y) => o("mountAutoFocus", y)
        ), l.dispatchEvent(m), m.defaultPrevented || (_n(Mn(vt(l)), {
          select: !0
        }), document.activeElement === p && J(l));
      }
      c(() => {
        l.removeEventListener(
          Se,
          (v) => o("mountAutoFocus", v)
        );
        const m = new CustomEvent(Te, Ke), y = (v) => {
          o("unmountAutoFocus", v);
        };
        l.addEventListener(Te, y), l.dispatchEvent(m), setTimeout(() => {
          m.defaultPrevented || J(p ?? document.body, { select: !0 }), l.removeEventListener(Te, y), u.remove(d);
        }, 0);
      });
    });
    function i(c) {
      if (!n.loop && !n.trapped || d.paused)
        return;
      const l = c.key === "Tab" && !c.altKey && !c.ctrlKey && !c.metaKey, p = document.activeElement;
      if (l && p) {
        const m = c.currentTarget, [y, v] = Pn(m);
        y && v ? !c.shiftKey && p === v ? (c.preventDefault(), n.loop && J(y, { select: !0 })) : c.shiftKey && p === y && (c.preventDefault(), n.loop && J(v, { select: !0 })) : p === m && c.preventDefault();
      }
    }
    return (c, l) => (C(), B(f(ne), {
      ref_key: "currentRef",
      ref: a,
      tabindex: "-1",
      "as-child": c.asChild,
      as: c.as,
      onKeydown: i
    }, {
      default: R(() => [
        M(c.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
});
function In(e) {
  return e ? "open" : "closed";
}
function Ln() {
  const e = "DialogContent", t = "DialogTitle", n = V(), o = `Warning: \`${e}\` requires a \`${t}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://www.radix-vue.com/components/dialog.html#title;`, a = `Warning: Missing \`Description\` or \`aria-describedby="undefined"\` for ${e}.`;
  ue(() => {
    var r;
    document.getElementById(n.titleId) || console.warn(o);
    const s = (r = n.contentElement.value) == null ? void 0 : r.getAttribute("aria-describedby");
    n.descriptionId && s && (document.getElementById(n.descriptionId) || console.warn(a));
  });
}
const ft = /* @__PURE__ */ S({
  __name: "DialogContentImpl",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = V(), { forwardRef: r, currentElement: s } = W();
    return ue(() => {
      a.contentElement = s;
    }), process.env.NODE_ENV !== "production" && Ln(), (u, d) => (C(), B(f(xn), {
      "as-child": "",
      loop: "",
      trapped: n.trapFocus,
      onMountAutoFocus: d[5] || (d[5] = (i) => o("openAutoFocus", i)),
      onUnmountAutoFocus: d[6] || (d[6] = (i) => o("closeAutoFocus", i))
    }, {
      default: R(() => [
        Ze(f(Tn), U({
          id: f(a).contentId,
          ref: f(r),
          as: u.as,
          "as-child": u.asChild,
          "disable-outside-pointer-events": u.disableOutsidePointerEvents,
          role: "dialog",
          "aria-describedby": f(a).descriptionId,
          "aria-labelledby": f(a).titleId,
          "data-state": f(In)(f(a).open.value)
        }, u.$attrs, {
          onDismiss: d[0] || (d[0] = (i) => f(a).onOpenChange(!1)),
          onEscapeKeyDown: d[1] || (d[1] = (i) => o("escapeKeyDown", i)),
          onFocusOutside: d[2] || (d[2] = (i) => o("focusOutside", i)),
          onInteractOutside: d[3] || (d[3] = (i) => o("interactOutside", i)),
          onPointerDownOutside: d[4] || (d[4] = (i) => o("pointerDownOutside", i))
        }), {
          default: R(() => [
            M(u.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "as", "as-child", "disable-outside-pointer-events", "aria-describedby", "aria-labelledby", "data-state"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), jn = /* @__PURE__ */ S({
  __name: "DialogContentModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = V(), r = we(o), { forwardRef: s, currentElement: u } = W();
    return gn(u), (d, i) => (C(), B(ft, U({ ...n, ...f(r) }, {
      ref: f(s),
      "trap-focus": f(a).open.value,
      "disable-outside-pointer-events": !0,
      onCloseAutoFocus: i[0] || (i[0] = (c) => {
        var l;
        o("closeAutoFocus", c), c.defaultPrevented || (c.preventDefault(), (l = f(a).triggerElement.value) == null || l.focus());
      }),
      onPointerDownOutside: i[1] || (i[1] = (c) => {
        const l = c.detail.originalEvent, p = l.button === 0 && l.ctrlKey === !0;
        (l.button === 2 || p) && c.preventDefault();
      }),
      onFocusOutside: i[2] || (i[2] = (c) => {
        c.preventDefault();
      }),
      onOpenAutoFocus: i[3] || (i[3] = (c) => o("openAutoFocus", c))
    }), {
      default: R(() => [
        M(d.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), kn = /* @__PURE__ */ S({
  __name: "DialogContentNonModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = we(o);
    W();
    const r = V(), s = b(!1), u = b(!1);
    return (d, i) => (C(), B(ft, U({ ...n, ...f(a) }, {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: i[0] || (i[0] = (c) => {
        var l;
        o("closeAutoFocus", c), c.defaultPrevented || (s.value || (l = f(r).triggerElement.value) == null || l.focus(), c.preventDefault()), s.value = !1, u.value = !1;
      }),
      onInteractOutside: i[1] || (i[1] = (c) => {
        var l;
        c.defaultPrevented || (s.value = !0, c.detail.originalEvent.type === "pointerdown" && (u.value = !0));
        const p = c.target;
        (l = f(r).triggerElement.value) != null && l.contains(p) && c.preventDefault(), c.detail.originalEvent.type === "focusin" && u.value && c.preventDefault();
      })
    }), {
      default: R(() => [
        M(d.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Fn = /* @__PURE__ */ S({
  __name: "DialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = V(), r = we(o), { forwardRef: s } = W();
    return (u, d) => (C(), B(f(dt), {
      present: u.forceMount || f(a).open.value
    }, {
      default: R(() => [
        f(a).modal.value ? (C(), B(jn, U({
          key: 0,
          ref: f(s)
        }, { ...n, ...f(r), ...u.$attrs }, {
          onOpenAutoFocus: d[0] || (d[0] = (i) => o("openAutoFocus", i))
        }), {
          default: R(() => [
            M(u.$slots, "default")
          ]),
          _: 3
        }, 16)) : (C(), B(kn, U({
          key: 1,
          ref: f(s)
        }, { ...n, ...f(r), ...u.$attrs }), {
          default: R(() => [
            M(u.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Un = /* @__PURE__ */ S({
  __name: "DialogOverlayImpl",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = V();
    return cn(!0), W(), (n, o) => (C(), B(f(ne), {
      as: n.as,
      "as-child": n.asChild,
      "data-state": f(t).open.value ? "open" : "closed",
      style: { "pointer-events": "auto" }
    }, {
      default: R(() => [
        M(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state"]));
  }
}), Wn = /* @__PURE__ */ S({
  __name: "DialogOverlay",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = V(), { forwardRef: n } = W();
    return (o, a) => {
      var r;
      return (r = f(t)) != null && r.modal.value ? (C(), B(f(dt), {
        key: 0,
        present: o.forceMount || f(t).open.value
      }, {
        default: R(() => [
          Ze(Un, U(o.$attrs, {
            ref: f(n),
            as: o.as,
            "as-child": o.asChild
          }), {
            default: R(() => [
              M(o.$slots, "default")
            ]),
            _: 3
          }, 16, ["as", "as-child"])
        ]),
        _: 3
      }, 8, ["present"])) : et("", !0);
    };
  }
}), ro = /* @__PURE__ */ S({
  __name: "DialogClose",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e;
    W();
    const n = V();
    return (o, a) => (C(), B(f(ne), U(t, {
      type: o.as === "button" ? "button" : void 0,
      onClick: a[0] || (a[0] = (r) => f(n).onOpenChange(!1))
    }), {
      default: R(() => [
        M(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), lo = /* @__PURE__ */ S({
  __name: "DialogTitle",
  props: {
    asChild: { type: Boolean },
    as: { default: "h2" }
  },
  setup(e) {
    const t = e, n = V();
    return W(), (o, a) => (C(), B(f(ne), U(t, {
      id: f(n).titleId
    }), {
      default: R(() => [
        M(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), so = /* @__PURE__ */ S({
  __name: "DialogDescription",
  props: {
    asChild: { type: Boolean },
    as: { default: "p" }
  },
  setup(e) {
    const t = e;
    W();
    const n = V();
    return (o, a) => (C(), B(f(ne), U(t, {
      id: f(n).descriptionId
    }), {
      default: R(() => [
        M(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), [mt, io] = be("CollectionProvider");
S({
  name: "CollectionSlot",
  setup(e, { slots: t }) {
    const n = mt(), { primitiveElement: o, currentElement: a } = ct();
    return k(a, () => {
      n.collectionRef.value = a.value;
    }), () => ie(Me, { ref: o }, t);
  }
});
S({
  name: "CollectionItem",
  setup(e, { slots: t, attrs: n }) {
    const o = mt(), { primitiveElement: a, currentElement: r } = ct(), s = Y();
    return te((u) => {
      var d;
      if (r.value) {
        const i = Ve(r.value);
        o.itemMap.value.set(i, { ref: r.value, ...Ve(((d = s == null ? void 0 : s.parent) == null ? void 0 : d.props) ?? {}) }), u(() => o.itemMap.value.delete(i));
      }
    }), () => ie(Me, { ...n, [o.attrName]: "", ref: a }, t);
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Hn = (e) => typeof e < "u";
function Vn(e) {
  return JSON.parse(JSON.stringify(e));
}
function Je(e, t, n, o = {}) {
  var a, r, s;
  const {
    clone: u = !1,
    passive: d = !1,
    eventName: i,
    deep: c = !1,
    defaultValue: l,
    shouldEmit: p
  } = o, m = Y(), y = n || (m == null ? void 0 : m.emit) || ((a = m == null ? void 0 : m.$emit) == null ? void 0 : a.bind(m)) || ((s = (r = m == null ? void 0 : m.proxy) == null ? void 0 : r.$emit) == null ? void 0 : s.bind(m == null ? void 0 : m.proxy));
  let v = i;
  t || (t = "modelValue"), v = v || `update:${t.toString()}`;
  const g = (h) => u ? typeof u == "function" ? u(h) : Vn(h) : h, O = () => Hn(e[t]) ? g(e[t]) : l, x = (h) => {
    p ? p(h) && y(v, h) : y(v, h);
  };
  if (d) {
    const h = O(), P = b(h);
    let A = !1;
    return k(
      () => e[t],
      (L) => {
        A || (A = !0, P.value = g(L), G(() => A = !1));
      }
    ), k(
      P,
      (L) => {
        !A && (L !== e[t] || c) && x(L);
      },
      { deep: c }
    ), P;
  } else
    return _({
      get() {
        return O();
      },
      set(h) {
        x(h);
      }
    });
}
const [xe, zn] = be("DrawerRoot"), yt = /* @__PURE__ */ new WeakMap();
function T(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement) || !t)
    return;
  const o = {};
  Object.entries(t).forEach(([a, r]) => {
    if (a.startsWith("--")) {
      e.style.setProperty(a, r);
      return;
    }
    o[a] = e.style[a], e.style[a] = r;
  }), !n && yt.set(e, o);
}
function _e(e, t) {
  if (!e || !(e instanceof HTMLElement))
    return;
  const n = yt.get(e);
  n && (t ? e.style[t] = n[t] : Object.entries(n).forEach(([o, a]) => {
    e.style[o] = a;
  }));
}
function ge(e) {
  const t = window.getComputedStyle(e), n = t.transform || t.webkitTransform || t.mozTransform;
  let o = n.match(/^matrix3d\((.+)\)$/);
  return o ? Number.parseFloat(o[1].split(", ")[13]) : (o = n.match(/^matrix\((.+)\)$/), o ? Number.parseFloat(o[1].split(", ")[5]) : null);
}
function Kn(e) {
  return 8 * (Math.log(e + 1) - 2);
}
const $ = {
  DURATION: 0.5,
  EASE: [0.32, 0.72, 0, 1]
}, gt = 0.4;
function Yn({
  activeSnapPoint: e,
  snapPoints: t,
  drawerRef: n,
  overlayRef: o,
  fadeFromIndex: a,
  onSnapPointChange: r
}) {
  const s = _(
    () => (t.value && e.value === t.value[t.value.length - 1]) ?? null
  ), u = _(
    () => t.value && t.value.length > 0 && ((a == null ? void 0 : a.value) || (a == null ? void 0 : a.value) === 0) && !Number.isNaN(a == null ? void 0 : a.value) && t.value[(a == null ? void 0 : a.value) ?? -1] === e.value || !t.value
  ), d = _(
    () => {
      var v;
      return ((v = t.value) == null ? void 0 : v.findIndex((g) => g === e.value)) ?? null;
    }
  ), i = _(
    () => {
      var v;
      return ((v = t.value) == null ? void 0 : v.map((g) => {
        const O = typeof window < "u", x = typeof g == "string";
        let h = 0;
        x && (h = Number.parseInt(g, 10));
        const P = x ? h : O ? g * window.innerHeight : 0;
        return O ? window.innerHeight - P : P;
      })) ?? [];
    }
  ), c = _(
    () => {
      var v;
      return d.value !== null ? (v = i.value) == null ? void 0 : v[d.value] : null;
    }
  ), l = (v) => {
    var O, x, h, P;
    const g = ((O = i.value) == null ? void 0 : O.findIndex((A) => A === v)) ?? null;
    G(() => {
      var A;
      r(g, i.value), T((A = n.value) == null ? void 0 : A.$el, {
        transition: `transform ${$.DURATION}s cubic-bezier(${$.EASE.join(",")})`,
        transform: `translate3d(0, ${v}px, 0)`
      });
    }), i.value && g !== i.value.length - 1 && g !== (a == null ? void 0 : a.value) ? T((x = o.value) == null ? void 0 : x.$el, {
      transition: `opacity ${$.DURATION}s cubic-bezier(${$.EASE.join(",")})`,
      opacity: "0"
    }) : T((h = o.value) == null ? void 0 : h.$el, {
      transition: `opacity ${$.DURATION}s cubic-bezier(${$.EASE.join(",")})`,
      opacity: "1"
    }), e.value = g !== null ? ((P = t.value) == null ? void 0 : P[g]) ?? null : null;
  };
  k(
    [e, i, t],
    () => {
      var v;
      if (e.value) {
        const g = ((v = t.value) == null ? void 0 : v.findIndex((O) => O === e.value)) ?? -1;
        i.value && g !== -1 && typeof i.value[g] == "number" && l(i.value[g]);
      }
    },
    {
      immediate: !0
      // if you want to run the effect immediately as well
    }
  );
  function p({
    draggedDistance: v,
    closeDrawer: g,
    velocity: O,
    dismissible: x
  }) {
    var Q, oe, Z;
    if (a === void 0)
      return;
    const h = (c.value ?? 0) - v, P = d.value === (a.value ?? 0) - 1, A = d.value === 0, L = v > 0;
    if (P && T((Q = o.value) == null ? void 0 : Q.$el, {
      transition: `opacity ${$.DURATION}s cubic-bezier(${$.EASE.join(",")})`
    }), O > 2 && !L) {
      x ? g() : l(i.value[0]);
      return;
    }
    if (O > 2 && L && i && t.value) {
      l(i.value[t.value.length - 1]);
      return;
    }
    const X = (oe = i.value) == null ? void 0 : oe.reduce((z, E) => typeof z != "number" || typeof E != "number" ? z : Math.abs(E - h) < Math.abs(z - h) ? E : z);
    if (O > gt && Math.abs(v) < window.innerHeight * 0.4) {
      const z = L ? 1 : -1;
      if (z > 0 && s) {
        l(i.value[(((Z = t.value) == null ? void 0 : Z.length) ?? 0) - 1]);
        return;
      }
      if (A && z < 0 && x && g(), d.value === null)
        return;
      l(i.value[d.value + z]);
      return;
    }
    l(X);
  }
  function m({ draggedDistance: v }) {
    var O;
    if (c.value === null)
      return;
    const g = c.value - v;
    T((O = n.value) == null ? void 0 : O.$el, {
      transform: `translate3d(0, ${g}px, 0)`
    });
  }
  function y(v, g) {
    if (!t || typeof d.value != "number" || !i.value || a === void 0)
      return null;
    const O = d.value === (a.value ?? 0) - 1;
    if (d.value >= (a.value ?? 0) && g)
      return 0;
    if (O && !g)
      return 1;
    if (!u.value && !O)
      return null;
    const h = O ? d.value + 1 : d.value - 1, P = O ? i.value[h] - i.value[h - 1] : i.value[h + 1] - i.value[h], A = v / Math.abs(P);
    return O ? 1 - A : A;
  }
  return {
    isLastSnapPoint: s,
    shouldFade: u,
    getPercentageDragged: y,
    activeSnapPointIndex: d,
    onRelease: p,
    onDrag: m,
    snapPointsOffset: i
  };
}
let se = null;
function qn(e) {
  const { isOpen: t, modal: n, nested: o, hasBeenOpened: a } = e, r = b(typeof window < "u" ? window.location.href : ""), s = b(0);
  function u() {
    if (se === null && t.value) {
      se = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height
      };
      const { scrollX: i, innerHeight: c } = window;
      document.body.style.position = "fixed", document.body.style.top = `-${s.value}px`, document.body.style.left = `-${i}px`, document.body.style.right = "0px", document.body.style.height = "auto", setTimeout(() => {
        requestAnimationFrame(() => {
          const l = c - window.innerHeight;
          l && s.value >= c && (document.body.style.top = `-${s.value + l}px`);
        });
      }, 300);
    }
  }
  function d() {
    if (se !== null) {
      const i = -Number.parseInt(document.body.style.top, 10), c = -Number.parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, se), requestAnimationFrame(() => {
        if (r.value !== window.location.href) {
          r.value = window.location.href;
          return;
        }
        window.scrollTo(c, i);
      }), se = null;
    }
  }
  return ue(() => {
    function i() {
      s.value = window.scrollY;
    }
    i(), window.addEventListener("scroll", i), Ce(() => {
      window.removeEventListener("scroll", i);
    });
  }), k([t, a, r], () => {
    o.value || !a.value || (t.value ? (u(), n || setTimeout(() => {
      d();
    }, 500)) : d());
  }), { restorePositionSetting: d };
}
const Jn = 0.25, Gn = 100, Ge = 8, ee = 16, Xn = 26, Xe = "vaul-dragging";
function Qn(e, t) {
  return e && e.value ? e : t;
}
function Zn(e) {
  const {
    emitDrag: t,
    emitRelease: n,
    emitClose: o,
    emitOpenChange: a,
    open: r,
    dismissible: s,
    nested: u,
    fixed: d,
    modal: i,
    shouldScaleBackground: c,
    scrollLockTimeout: l,
    closeThreshold: p,
    activeSnapPoint: m,
    fadeFromIndex: y
  } = e, v = b(!1), g = b(!1), O = b(!1), x = b(!1), h = b(null), P = b(null), A = b(null), L = b(null), X = b(null), Q = b(!0), oe = b(null), Z = b(0), z = b(!1);
  b(0);
  const E = b(null);
  b(0);
  const Ie = _(() => {
    var w;
    return ((w = E.value) == null ? void 0 : w.$el.getBoundingClientRect().height) || 0;
  }), H = Qn(
    e.snapPoints,
    b(void 0)
  ), {
    activeSnapPointIndex: Le,
    onRelease: ht,
    snapPointsOffset: bt,
    onDrag: wt,
    shouldFade: je,
    getPercentageDragged: Ot
  } = Yn({
    snapPoints: H,
    activeSnapPoint: m,
    drawerRef: E,
    fadeFromIndex: y,
    overlayRef: h,
    onSnapPointChange: Et
  });
  function Et(w, D) {
    H.value && w === D.length - 1 && (P.value = /* @__PURE__ */ new Date());
  }
  const { restorePositionSetting: Dt } = qn({
    isOpen: r,
    modal: i,
    nested: u,
    hasBeenOpened: v
  });
  function de() {
    return (window.innerWidth - Xn) / window.innerWidth;
  }
  function ke(w, D) {
    var q;
    if (!w)
      return !1;
    let N = w;
    const I = (q = window.getSelection()) == null ? void 0 : q.toString(), j = E.value ? ge(E.value.$el) : null, F = /* @__PURE__ */ new Date();
    if (P.value && F.getTime() - P.value.getTime() < 500)
      return !1;
    if (j && j > 0)
      return !0;
    if (I && I.length > 0)
      return !1;
    if (X.value && F.getTime() - X.value.getTime() < l.value && j === 0 || D)
      return X.value = F, !1;
    for (; N; ) {
      if (N.scrollHeight > N.clientHeight) {
        if (N.scrollTop !== 0)
          return X.value = /* @__PURE__ */ new Date(), !1;
        if (N.getAttribute("role") === "dialog")
          return !0;
      }
      N = N.parentNode;
    }
    return !0;
  }
  function $t(w) {
    !s.value && !H.value || E.value && !E.value.$el.contains(w.target) || (O.value = !0, A.value = /* @__PURE__ */ new Date(), w.target.setPointerCapture(w.pointerId), Z.value = w.screenY);
  }
  function At(w) {
    var D, N, I, j, F, q;
    if (O.value) {
      const ve = Z.value - w.screenY, Oe = ve > 0;
      if (H.value && Le.value === 0 && !s.value || !Q.value && !ke(w.target, Oe))
        return;
      if ((D = E == null ? void 0 : E.value) == null || D.$el.classList.add(Xe), Q.value = !0, T((N = E.value) == null ? void 0 : N.$el, {
        transition: "none"
      }), T((I = h.value) == null ? void 0 : I.$el, {
        transition: "none"
      }), H.value && wt({ draggedDistance: ve }), Oe && !H.value) {
        const De = Kn(ve);
        T((j = E.value) == null ? void 0 : j.$el, {
          transform: `translate3d(0, ${Math.min(De * -1, 0)}px, 0)`
        });
        return;
      }
      const Ee = Math.abs(ve), We = document.querySelector("[vaul-drawer-wrapper]");
      let ae = Ee / Ie.value;
      const He = Ot(
        Ee,
        Oe
      );
      He !== null && (ae = He);
      const Nt = 1 - ae;
      if ((je.value || y.value && Le.value === y.value - 1) && (t(ae), T(
        (F = h.value) == null ? void 0 : F.$el,
        {
          opacity: `${Nt}`,
          transition: "none"
        },
        !0
      )), We && h.value && c.value) {
        const De = Math.min(de() + ae * (1 - de()), 1), Ct = 8 - ae * 8, Bt = Math.max(0, 14 - ae * 14);
        T(
          We,
          {
            borderRadius: `${Ct}px`,
            transform: `scale(${De}) translate3d(0, ${Bt}px, 0)`,
            transition: "none"
          },
          !0
        );
      }
      H.value || T((q = E.value) == null ? void 0 : q.$el, {
        transform: `translate3d(0, ${Ee}px, 0)`
      });
    }
  }
  function Fe() {
    var N;
    if (!E.value)
      return;
    const w = document.querySelector("[vaul-drawer-wrapper]"), D = ge(E.value.$el);
    T(E.value.$el, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${$.DURATION}s cubic-bezier(${$.EASE.join(",")})`
    }), T((N = h.value) == null ? void 0 : N.$el, {
      transition: `opacity ${$.DURATION}s cubic-bezier(${$.EASE.join(",")})`,
      opacity: "1"
    }), c.value && D && D > 0 && r && T(
      w,
      {
        borderRadius: `${Ge}px`,
        overflow: "hidden",
        transform: `scale(${de()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${$.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${$.EASE.join(",")})`
      },
      !0
    );
  }
  function pe() {
    var w;
    E.value && (T(E.value.$el, {
      transform: "translate3d(0, 100%, 0)",
      transition: `transform ${$.DURATION}s cubic-bezier(${$.EASE.join(",")})`
    }), T((w = h.value) == null ? void 0 : w.$el, {
      opacity: "0",
      transition: `opacity ${$.DURATION}s cubic-bezier(${$.EASE.join(",")})`
    }), Ue(!1), Dt(), g.value = !1, window.setTimeout(() => {
      a(!1);
    }, 300), window.setTimeout(() => {
      H.value && (m.value = H.value[0]);
    }, $.DURATION * 1e3));
  }
  function St(w) {
    if (!O.value || !E.value)
      return;
    E.value.$el.classList.remove(Xe), Q.value = !1, O.value = !1, L.value = /* @__PURE__ */ new Date();
    const D = ge(E.value.$el);
    if (!ke(w.target, !1) || !D || Number.isNaN(D) || A.value === null)
      return;
    const N = L.value.getTime() - A.value.getTime(), I = Z.value - w.screenY, j = Math.abs(I) / N;
    if (j > 0.05 && (x.value = !0, window.setTimeout(() => {
      x.value = !1;
    }, 200)), H.value) {
      ht({
        draggedDistance: I,
        closeDrawer: pe,
        velocity: j,
        dismissible: s.value
      }), n(!0);
      return;
    }
    if (I > 0) {
      Fe(), n(!0);
      return;
    }
    if (j > gt) {
      pe(), n(!1);
      return;
    }
    const F = Math.min(
      E.value.$el.getBoundingClientRect().height ?? 0,
      window.innerHeight
    );
    if (D >= F * p.value) {
      pe(), n(!1);
      return;
    }
    n(!0), Fe();
  }
  k(r, (w) => {
    w && (P.value = /* @__PURE__ */ new Date(), Ue(!0)), a(w);
  });
  function Ue(w) {
    const D = document.querySelector("[vaul-drawer-wrapper]");
    !D || !c.value || (w ? (T(
      document.body,
      {
        background: "black"
      },
      !0
    ), T(D, {
      borderRadius: `${Ge}px`,
      overflow: "hidden",
      transform: `scale(${de()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
      transformOrigin: "top",
      transitionProperty: "transform, border-radius",
      transitionDuration: `${$.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${$.EASE.join(",")})`
    })) : (_e(D, "overflow"), _e(D, "transform"), _e(D, "borderRadius"), T(D, {
      transitionProperty: "transform, border-radius",
      transitionDuration: `${$.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${$.EASE.join(",")})`
    })));
  }
  function Tt(w) {
    var I, j;
    const D = w ? (window.innerWidth - ee) / window.innerWidth : 1, N = w ? -ee : 0;
    oe.value && window.clearTimeout(oe.value), T((I = E.value) == null ? void 0 : I.$el, {
      transition: `transform ${$.DURATION}s cubic-bezier(${$.EASE.join(",")})`,
      transform: `scale(${D}) translate3d(0, ${N}px, 0)`
    }), !w && ((j = E.value) != null && j.$el) && (oe.value = window.setTimeout(() => {
      var F, q;
      T((F = E.value) == null ? void 0 : F.$el, {
        transition: "none",
        transform: `translate3d(0, ${ge((q = E.value) == null ? void 0 : q.$el)}px, 0)`
      });
    }, 500));
  }
  function _t(w) {
    var j;
    if (w < 0)
      return;
    const D = (window.innerWidth - ee) / window.innerWidth, N = D + w * (1 - D), I = -ee + w * ee;
    T((j = E.value) == null ? void 0 : j.$el, {
      transform: `scale(${N}) translate3d(0, ${I}px, 0)`,
      transition: "none"
    });
  }
  function Pt(w) {
    var I;
    const D = w ? (window.innerWidth - ee) / window.innerWidth : 1, N = w ? -ee : 0;
    w && T((I = E.value) == null ? void 0 : I.$el, {
      transition: `transform ${$.DURATION}s cubic-bezier(${$.EASE.join(
        ","
      )})`,
      transform: `scale(${D}) translate3d(0, ${N}px, 0)`
    });
  }
  return {
    isOpen: r,
    modal: i,
    keyboardIsOpen: z,
    hasBeenOpened: v,
    isVisible: g,
    drawerRef: E,
    drawerHeightRef: Ie,
    overlayRef: h,
    isDragging: O,
    dragStartTime: A,
    isAllowedToDrag: Q,
    snapPoints: H,
    activeSnapPoint: m,
    pointerStartY: Z,
    dismissible: s,
    snapPointsOffset: bt,
    shouldFade: je,
    fadeFromIndex: y,
    shouldScaleBackground: c,
    onPress: $t,
    onDrag: At,
    onRelease: St,
    closeDrawer: pe,
    onNestedDrag: _t,
    onNestedRelease: Pt,
    onNestedOpenChange: Tt,
    emitClose: o,
    emitDrag: t,
    emitRelease: n,
    emitOpenChange: a,
    nested: u
  };
}
const eo = /* @__PURE__ */ S({
  __name: "DrawerRoot",
  props: {
    activeSnapPoint: { default: void 0 },
    closeThreshold: { default: Jn },
    shouldScaleBackground: { type: Boolean, default: void 0 },
    scrollLockTimeout: { default: Gn },
    fixed: { type: Boolean, default: void 0 },
    dismissible: { type: Boolean, default: !0 },
    modal: { type: Boolean, default: !0 },
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    nested: { type: Boolean, default: !1 },
    snapPoints: { default: void 0 },
    fadeFromIndex: { default: void 0 }
  },
  emits: ["drag", "release", "close", "update:open", "update:activeSnapPoint"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = _(() => n.fadeFromIndex ?? (n.snapPoints && n.snapPoints.length - 1)), r = Je(n, "open", o, {
      defaultValue: n.defaultOpen,
      passive: n.open === void 0
    }), s = Je(n, "activeSnapPoint", o, {
      passive: n.activeSnapPoint === void 0
    }), u = {
      emitDrag: (p) => o("drag", p),
      emitRelease: (p) => o("release", p),
      emitClose: () => o("close"),
      emitOpenChange: (p) => {
        r.value = p;
      }
    }, { closeDrawer: d, hasBeenOpened: i, modal: c } = zn(
      Zn({
        ...u,
        ...Ne(n),
        activeSnapPoint: s,
        fadeFromIndex: a,
        open: r
      })
    );
    function l(p) {
      p ? (i.value = !0, r.value = p) : d();
    }
    return (p, m) => (C(), B(f(On), {
      open: f(r),
      modal: f(c),
      "onUpdate:open": l
    }, {
      default: R(() => [
        M(p.$slots, "default")
      ]),
      _: 3
    }, 8, ["open", "modal"]));
  }
}), uo = /* @__PURE__ */ S({
  __name: "DrawerRootNested",
  props: {
    activeSnapPoint: {},
    closeThreshold: {},
    shouldScaleBackground: { type: Boolean },
    scrollLockTimeout: {},
    fixed: { type: Boolean },
    dismissible: { type: Boolean },
    modal: { type: Boolean },
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    nested: { type: Boolean },
    snapPoints: {},
    fadeFromIndex: {}
  },
  emits: ["drag", "release", "close", "update:open", "update:activeSnapPoint"],
  setup(e, { emit: t }) {
    const n = e, o = t, { onNestedDrag: a, onNestedOpenChange: r, onNestedRelease: s } = xe();
    function u() {
      r(!1);
    }
    function d(l) {
      a(l);
    }
    function i(l) {
      l && r(l), o("update:open", l);
    }
    const c = pn(n, o);
    return (l, p) => (C(), B(eo, U(f(c), {
      nested: "",
      onClose: u,
      onDrag: d,
      onRelease: f(s),
      "onUpdate:open": i
    }), {
      default: R(() => [
        M(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["onRelease"]));
  }
}), co = /* @__PURE__ */ S({
  __name: "DrawerOverlay",
  setup(e) {
    const { overlayRef: t, snapPoints: n, isVisible: o, isOpen: a, shouldFade: r } = xe(), s = _(() => {
      var u;
      return n && (((u = n.value) == null ? void 0 : u.length) ?? 0) > 0;
    });
    return (u, d) => (C(), B(f(Wn), {
      ref_key: "overlayRef",
      ref: t,
      "vaul-drawer-visible": f(o) ? "true" : "false",
      "vaul-overlay": "",
      "vaul-snap-points": f(a) && s.value ? "true" : "false",
      "vaul-snap-points-overlay": f(a) && f(r) ? "true" : "false"
    }, null, 8, ["vaul-drawer-visible", "vaul-snap-points", "vaul-snap-points-overlay"]));
  }
}), po = /* @__PURE__ */ S({
  __name: "DrawerContent",
  setup(e) {
    const {
      isOpen: t,
      isVisible: n,
      snapPointsOffset: o,
      drawerRef: a,
      onPress: r,
      onDrag: s,
      onRelease: u,
      modal: d,
      emitOpenChange: i,
      dismissible: c,
      keyboardIsOpen: l,
      closeDrawer: p
    } = xe(), m = _(() => o.value && o.value.length > 0 ? `${o.value[0]}px` : "0");
    function y(v) {
      if (!d.value || v.defaultPrevented) {
        v.preventDefault();
        return;
      }
      l.value && (l.value = !1), v.preventDefault(), c.value && p();
    }
    return k(
      t,
      (v) => {
        v && setTimeout(() => {
          n.value = !0;
        }, 1);
      },
      { immediate: !0 }
    ), (v, g) => (C(), B(f(Fn), {
      ref_key: "drawerRef",
      ref: a,
      "vaul-drawer": "",
      "vaul-drawer-visible": f(n) ? "true" : "false",
      style: ot({ "--snap-point-height": m.value }),
      onPointerdown: f(r),
      onPointermove: f(s),
      onPointerup: f(u),
      onPointerDownOutside: y
    }, {
      default: R(() => [
        M(v.$slots, "default")
      ]),
      _: 3
    }, 8, ["vaul-drawer-visible", "style", "onPointerdown", "onPointermove", "onPointerup"]));
  }
});
export {
  ro as DrawerClose,
  po as DrawerContent,
  so as DrawerDescription,
  co as DrawerOverlay,
  ao as DrawerPortal,
  eo as DrawerRoot,
  uo as DrawerRootNested,
  lo as DrawerTitle,
  oo as DrawerTrigger
};
